/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';
import {
  Link,
  useLocation,
  /*:: type Location,
  type LocationShape, */
} from 'react-router-dom';

/*:: type Props = {
  to: string | LocationShape | ((location: Location) => LocationShape),
}; */

export function RelativeLink({to: relativeTo, ...props} /*: Props */) /*: React$Node */ {
  const location = useLocation();
  let to;

  if (typeof relativeTo === 'string') {
    to = {...location, pathname: relativeTo};
  } else if (typeof relativeTo === 'function') {
    to = relativeTo(location);
  } else {
    // $FlowIssue
    to = {...location, ...relativeTo};
  }

  return html`<${Link} to=${to} ...${props} />`;
}
